<template>
    <div id="error-widget" class="pl-3 pr-3 fixed-bottom" v-if="isVisible" >
      <div :class="(isVisible ? 'show' : 'hide') + ' alert ' + alertClass + ' alert-dismissible fade'" role="alert">
        <strong v-if="isError && statusCode > 200">Error {{statusCode}} {{statusText}}:</strong> <div class="error-message">{{message}}</div>
          <span v-if="isHttp401">You seem to be signed out. Please <a href="/signin">sign in</a>.</span>
            <button class="close" @click="hide">
                <span>&times;</span>
            </button>
          <div v-if="isError">
          <a href="/about/contacts">Contact us</a> if this error persists.
          </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';


export interface Xhr {
  status: number;
  statusText: string;
}

@Component
export default class ErrorWidget extends Vue {
  public statusCode = 200;
  public statusText = '';
  public message = '';
  public isVisible = false;
  private isError = true;

  public get alertClass(): string {
    return this.isError ? 'alert-danger' : 'alert-info';
  }

  private get isHttp401(): boolean {
    return this.statusCode === 401;
  }

  public show() {
    this.isVisible = true;
  }

  public hide() {
    this.isVisible = false;
  }

  public handleXhrError(xhr: Xhr, msg: string) {
    this.isError = true;
    this.statusCode = xhr.status;
    this.statusText = xhr.statusText;
    this.message = msg;
    this.show();
  }

  public showError(msg: string) {
    this.isError = true;
    this.statusCode = 0;
    this.statusText = '';
    this.message = msg;
    this.show();
  }

  public showInfo(msg: string) {
    this.isError = false;
    this.statusCode = 0;
    this.statusText = '';
    this.message = msg;
    this.show();
  }
}
</script>

<style scoped lang="scss">
#error-widget {
  z-index: 1200;

  .error-message {
    white-space: pre-line;
  }
}
</style>
